var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeauty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5618 15.9324L4.77526 11.4717V27.8425H3.29211V42.7189H12.0449V27.8425H10.5618V15.9324Z",
    fill: "#0F5671"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7078 33.7871H15.6629V43.259H36.7078V33.7871Z",
    fill: "#0F5671"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0787 22.5284C16.0787 28.1126 20.6068 32.6295 26.1798 32.6295C31.7528 32.6295 36.2922 28.1014 36.2922 22.5284C36.2922 16.9553 31.7641 12.416 26.191 12.416C20.618 12.416 16.0787 16.9441 16.0787 22.5284ZM27.8202 17.1913L32.9438 22.3711L32.6517 22.6632L27.5281 17.4834L27.8202 17.1913ZM23.0113 17.5396L30.382 24.9666L30.0899 25.2587L22.7191 17.8317L23.0113 17.5396Z",
    fill: "#0F5671"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06742 9.31422L3.42697 8.42658L2.52809 6.78613L1.64045 8.42658L0 9.31422L1.64045 10.2131L2.52809 11.8423L3.42697 10.2131L5.06742 9.31422Z",
    fill: "#0F5671"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6404 2.19043L12.1124 3.16796L11.1348 3.69605L12.1124 4.23537L12.6404 5.2129L13.1798 4.23537L14.1573 3.69605L13.1798 3.16796L12.6404 2.19043Z",
    fill: "#0F5671"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4045 13.2246L34.382 12.6853L33.4045 12.1572L32.8652 11.1797L32.3371 12.1572L31.3596 12.6853L32.3371 13.2246L32.8652 14.2022L33.4045 13.2246Z",
    fill: "#0F5671"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2472 5.14607L28.1573 3.48315L29.8314 2.57303L28.1573 1.66292L27.2472 0L26.3371 1.66292L24.6741 2.57303L26.3371 3.48315L27.2472 5.14607Z",
    fill: "#0F5671"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0225 4.29198L38.4832 3.31445L37.9551 4.29198L36.9775 4.82007L37.9551 5.3594L38.4832 6.33693L39.0225 5.3594L40 4.82007L39.0225 4.29198Z",
    fill: "#0F5671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeauty);
export default __webpack_public_path__ + "static/media/beauty.e5952cf7a2b40ee91eb5d17f35b24954.svg";
export { ForwardRef as ReactComponent };